import PageReady from './page-ready';

export const singleton = new PageReady();
